import styled from 'styled-components'

export const Wrapper = styled.form`
  display: flex;
  flex-direction: column;
  height: 100%;
`

export const Content = styled.div`
  flex: 1 0;
  display: flex;
  justify-content: center;
  flex-direction: column;
`

export const RadiosWrapper = styled.div`
  div + div {
    margin-top: 22px;
  }
  margin-top: 20px;
  margin-bottom: 10px;
`
